import { Button, Grid, List, ListItem, ListItemText } from "@material-ui/core";
import React, { useState } from "react";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";
import ProdutosAdicionados from "../../Orcamentos/Tabelas/ProdutosAdicionados";
import FiltrarGrupoProduto from "../Forms/FiltrarGrupoProduto";

const AdicionarProduto = (props) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [formData, SetFormData] = useState({
		nome: "",
		categoria: "",
		cor: "",
    linha: ""
	});

	const [itensFiltrados, setItensFiltrados] = useState(
		props.gruposDeProdutosLista
	);

	const SelecionaProduto = (productGroup) => {
		let insert = true;
		props.orcamentoProdutos.map((productGroupTest) => {
			if (productGroup.id === productGroupTest.id) insert = false;
		});

		if (insert) {
			const item = {
				id: productGroup.id,
				nome: productGroup.nome,
				categoria: productGroup.categoria,
				valor_tabela: productGroup.valor_tabela,
				valor_final: productGroup.valor_tabela,
				valor_unitario: productGroup.valor_tabela,
				desconto: 0,
				quantidade: 1,
			};

			props.AtualizaDadosOrcamento({
				listaPordutos: props.orcamentoProdutos.concat(item),
			});

			const divScroll = document.getElementById("produtoSelecionadosContainer");
			if (divScroll)
				setTimeout(function () {
					divScroll.scrollTo(0, 9999999999999);
				}, 200);
		}
	};

	const SetFiltraDados = (data) => {
		SetFormData(data);
		if (data.nome !== "" || data.categoria !== "" || data.cor !== "" || data.linha !== "") {
			setItensFiltrados(filtrarItens(props.gruposDeProdutosLista, data));
		} else {
			setItensFiltrados(props.gruposDeProdutosLista);
		}
	};

	const filtrarItens = (arr, data) => {
		let compararQtd = 0;

		if (data.nome !== "") compararQtd++;
		if (data.categoria !== "") compararQtd++;
		if (data.cor !== "") compararQtd++;
		if (data.linha !== "") compararQtd++;

		const dicionarioCores = {
			preto: ["preto", "preta", "black"],
			azul: ["azul", "blue"],
			branco: ["branco", "branca", "white"],
			vermelho: ["vermelho", "vermelha", "red"],
			verde: ["verde", "green"],
			cinza: ["cinza", "grey", "gray"],
			amarelo: ["amarelo", "amarela", "yellow"],
			roxo: ["roxo", "roxa", "purple"],
			rosa: ["rosa", "pink"],
			laranja: ["laranja", "orange"],
			marrom: ["marrom", "brown"],
			bege: ["bege", "beige"],
			violeta: ["violeta", "violet"],
			dourado: ["dourado", "dourada", "gold"],
			prata: ["prata", "silver"],
			turquesa: ["turquesa", "turquoise"],
			magenta: ["magenta", "fuchsia"],
			ciano: ["ciano", "cyan"],
			castanho: ["castanho", "castanha", "chestnut", "auburn"]
	};


		return arr.filter((el) => {
			let iguais = 0;

			if (data.cor !== "") {
				const corSelecionada = data.cor.toLowerCase();

				const variacoesCor = dicionarioCores[corSelecionada] || [corSelecionada];

				const corEncontrada = variacoesCor.some((corVariante) =>
					el.nome.toLowerCase().includes(corVariante)
				);

				if (corEncontrada) {
					iguais++;
				}
			}

			if (
				data.nome !== "" &&
				el.nome.toLowerCase().search(data.nome.toLowerCase()) !== -1
			)
				iguais++;

			if (
				data.categoria !== "" &&
				el.categoria.toLowerCase().search(data.categoria.toLowerCase()) !== -1
			)
				iguais++;

			if (
				data.linha !== "" &&
				el.nome.toLowerCase().includes(data.linha.toLowerCase())
			)
				iguais++;

			return iguais >= compararQtd;
		});
	};

	return (
		<React.Fragment>
			{modalOpen && (
				<Backdrop>
					<Modal
						title="Inserir produto"
						onCancel={() => {
							SetFormData({ nome: "", categoria: "", cor: "", linha: "" });
							// SetSearchResults(null);
							SetModalOpen(false);
						}}
						onCancelTopo={true}
						size="full"
						onConfirmLabel="Inserir produto"
					>
						<Grid container spacing={3} className="lista-produtos-container" style={{marginTop: 10}}>
							<Grid item xs={6} className="lista-produtos-e">
                <Grid container spacing={2}>
                  <Grid item xs={10}>
                    <h3 className="text-left">Lista de produtos</h3>
                  </Grid>
                  <Grid item xs={2} style={{justifyContent: 'flex-end', display: 'flex'}}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => SetFiltraDados({
                        nome: "",
                        categoria: "",
                        cor: "",
                        linha: ""
                      })}
                    >
                      Limpar filtros
                    </Button>
                  </Grid>
                </Grid>
								<FiltrarGrupoProduto
									formData={formData}
									SetFiltraDados={SetFiltraDados}
									SetFormData={SetFormData}
                  gruposDeProdutosLinha={props.gruposDeProdutosLinha}
                  gruposDeProdutosCor={props.gruposDeProdutosCor}
									// loading={loading}
								/>
								{itensFiltrados && itensFiltrados.length > 0 && (
									<List component="nav" aria-label="secondary mailbox folders">
										<div className="addProductGroups__container">
											{itensFiltrados.map((produto) => {
												return (
													<ListItem
														button
														key={produto.id}
														onClick={() => SelecionaProduto(produto)}
														className=""
													>
														<ListItemText
															primary={produto.nome}
															secondary={
																produto.valor_tabela.toLocaleString("pt-BR", {
																	style: "currency",
																	currency: "BRL",
																}) +
																" - " +
																produto.categoria
															}
														/>
													</ListItem>
												);
												// }
											})}
										</div>
									</List>
								)}
							</Grid>
							<Grid item xs={6} className="lista-produtos-d">
								<div className="adiciona-produto-tabela-selecionados">
									<h3 className="text-center">Produtos no orçamento</h3>
									<p className="text-center">
										Total sem descontos:
										<b>
											{props.orcamentoResumo.totalSemDesconto.toLocaleString(
												"pt-BR",
												{
													style: "currency",
													currency: "BRL",
												}
											)}
										</b>
									</p>

									<ProdutosAdicionados
										orcamentoProdutos={props.orcamentoProdutos}
										AdicionaRemoveProduto={props.AdicionaRemoveProduto}
										orcamentoResumo={props.orcamentoResumo}
										simples
									/>
								</div>
							</Grid>
						</Grid>
					</Modal>
				</Backdrop>
			)}
			<Button
				onClick={() => SetModalOpen(true)}
				variant="contained"
				color="primary"
				size="small"
			>
				Inserir produto
			</Button>
		</React.Fragment>
	);
};

export default AdicionarProduto;
